// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type IsLessThanOrEqualTo from "../contract/IsLessThanOrEqualTo";

export default function isLessThanOrEqualTo(data: IsLessThanOrEqualTo): IsLessThanOrEqualTo {
    const result: IsLessThanOrEqualTo = {
        __type: "IsLessThanOrEqualTo:#Exchange",
        ...data,
    };
    
    return result;
}
